import { DashboardSdk } from '@bringg/frontend-utils';
import {
  CreateTaskInventory,
  CreateTaskWaypoint,
  Customer,
  Merchant,
  PickupDropoffOption,
  Task,
  TaskTypeId,
} from '@bringg/types';

import { TAX_FEE } from 'Consts';
import { saveTask } from 'Services';
import { DeliveryOptions, ECommerceSettings } from 'Types';
import { buildBaseTask } from '../helpers';

const mapToCurbsideTask = (
  settings: ECommerceSettings,
  customer: Customer,
  taskInventories: CreateTaskInventory[],
  merchant: Merchant
): Task => {
  const pickUpWayPoint: CreateTaskWaypoint = {
    address: settings.team.address,
    customer,
    merchant_id: merchant.id,
    inventory: taskInventories,
    position: 1,
    pickup_dropoff_option: PickupDropoffOption.PICKUP,
  };

  const totalPrice = taskInventories
    .map((task) => (task.original_quantity as number) * (task.price as number))
    .reduce((prev, curr) => prev + curr, 0);

  return {
    ...buildBaseTask(settings.team, { ...customer, phone: undefined }),
    way_points: [pickUpWayPoint],
    task_type_id: TaskTypeId.CLICK_AND_COLLECT,
    tag_id: settings.tag.id,
    total_price: totalPrice,
    price_before_tax: totalPrice * (1 - TAX_FEE),
    tax_price: totalPrice * TAX_FEE,
    virtual_task: true,
  } as Task;
};

export const createCurbsideDeliveryTask = async (
  settings: ECommerceSettings,
  customer: Customer,
  inventories: CreateTaskInventory[],
  delivery: DeliveryOptions,
  dashboardSDK: DashboardSdk,
  onProgress?: (percent: number) => void
): Promise<Task> => {
  const merchant = await dashboardSDK.sdk.merchant.get();
  const task = mapToCurbsideTask(settings, customer, inventories, merchant);

  onProgress && onProgress(100);
  return await saveTask(task);
};
